import React, { useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import LkButton from "components/lk/lkButton";
import { ROUTES_PATHS } from "const";
import { useOnScreen } from "hooks";
import logo from "../assets/images/logo.svg";

import "../styles/footer.css";
import { useStores } from "hooks/useStores";
import AnchorButton from "components/AnchorButton";


const Footer = () => {
  const footerRef = useRef(null);
  const { modalStore, api } = useStores();

  useEffect(() => {
    api.content.getPageApi("contacts")
    .then((response) => {
      if (response.init_state?.staff) {
        setFooterStuff(response.init_state.staff);
      }
    })
  }, [])


  const isFooterVisible = useOnScreen(footerRef,{
    root: null,
    rootMargin: "0px 0px 0px 0px",
    threshold: 0.3
  });

  const footerYear = new Date().getFullYear();


  const setFooterStuff = (staffItems) => {
    const footerStuffImages = document.querySelector(".footer-question-images");
    staffItems.map((item, i) =>
      footerStuffImages.querySelectorAll("img")[i].src = item.icon_1
    );
  };


  const handleClickCall = () => {
    modalStore.open("callback");
  }

  return (
    <>
      <footer ref={footerRef} className='footer'>
        <div className='footer-wrap'>
          <div className='footer-content'>
            <div className='footer-info'>
              <h2 className='footer-title'>компания</h2>
              <Link to='/'>
                <img loading="lazy" className='footer-logo' src={logo} alt='Пак Пакыч' />
              </Link>
              <div className='footer-info__wrap'>
                <h3 className='footer-info__subtitle'>ООО «СПП»</h3>
                <p className='footer-info__descr'>
                  Все права защищены ©&nbsp;
                  <span className='js-footer-year'>{footerYear}</span>
                </p>
              </div>
            </div>
            <div className='footer-about'>
              <h2 className='footer-title'>меню</h2>
              <ul className='footer-links'>
                <li className='footer-links__item'>
                  <Link to={ROUTES_PATHS.MAIN} className='footer-list__link'>
                    Главная
                  </Link>
                </li>
                <li className='footer-links__item'>
                  <Link to={ROUTES_PATHS.USEFUL} className='footer-list__link'>
                    Полезная информация
                  </Link>
                </li>
                <li className='footer-links__item'>
                  <Link to={ROUTES_PATHS.ARTICLES} className='footer-list__link'>
                    Статьи
                  </Link>
                </li>
                <li className='footer-links__item'>
                  <Link
                    to={ROUTES_PATHS.CERTIFICATES}
                    className='footer-list__link'
                  >
                    Сертификаты
                  </Link>
                </li>
                <li className='footer-links__item'>
                  <Link
                    to={ROUTES_PATHS.DELIVERY}
                    className='footer-list__link'
                  >
                    Доставка и оплата
                  </Link>
                </li>
                <li className='footer-links__item'>
                  <Link
                    to={ROUTES_PATHS.CONTACTS}
                    className='footer-list__link'
                  >
                    Контакты
                  </Link>
                </li>
              </ul>
            </div>
            <div className='footer-question'>
              <h2 className='footer-title'>Вопрос по заказу?</h2>
              <div className='footer-question-images'>
                <Link to={ROUTES_PATHS.CONTACTS}>
                  <img loading="lazy" src='' width='52' alt='Footer' />
                </Link>
                <Link to={ROUTES_PATHS.CONTACTS}>
                  <img loading="lazy" src='' width='52' alt='Footer' />
                </Link>
                <Link to={ROUTES_PATHS.CONTACTS}>
                  <img loading="lazy" src='' width='52' alt='Footer' />
                </Link>
                <Link to={ROUTES_PATHS.CONTACTS}>
                  <img loading="lazy" src='' width='52' alt='Footer' />
                </Link>
              </div>
              <div className='footer-action'>
                <div className='footer-action-buttons'>
                  <a href='tel:+74951201251'>+7 (495) 120 12 51</a>
                  <span className='vertical-dash'>|</span>
                  <button className='footer-action-button' onClick={handleClickCall}>Заказать звонок</button>
                </div>
              </div>
            </div>
            <div className='footer-basket'>
              <h2 className='footer-title'>ЛИЧНЫЙ КАБИНЕт</h2>
              <div className='basket-link'>
                <LkButton />
              </div>
              <AnchorButton isFooterVisible={isFooterVisible} />
            </div>
          </div>
        </div>
      </footer>
    </>
  );
};

export { Footer };
